import type { RouteLocationNormalizedGeneric } from '#vue-router'
import type { DemoSlotsPaginatedData } from '../../model/demo-slot/interfaces'
import type { ApiCallbacks } from '@shared/api'

import { runApiGet } from '@shared/api'
import { pick } from '@shared/lib/collections'
import { getFirstQueryValue, normalizeArrayQuery, useAdminRoutes } from '@shared/lib/routes'

import { useDemoShiftControlStore } from '../../model/shift-control/store'

interface SlotsTrackerApiOptions extends ApiCallbacks<DemoSlotsPaginatedData> {
  route?: RouteLocationNormalizedGeneric
}

export const useSlotsTrackerApi = async (options?: SlotsTrackerApiOptions): Promise<DemoSlotsPaginatedData | null> => {
  const route = options?.route || useRoute()
  const demoShiftControlStore = useDemoShiftControlStore()

  const url = useAdminRoutes('admin.demo-slots.tracker', pick({
    from: getFirstQueryValue(route.query?.from) || demoShiftControlStore.getFilterFrom!,
    to: getFirstQueryValue(route.query?.to) || demoShiftControlStore.getFilterTo!,
    statuses: normalizeArrayQuery(route.query?.statuses),
    reservation_types: normalizeArrayQuery(route.query?.reservation_types),
    sort_by: getFirstQueryValue(route.query?.sort_by) || demoShiftControlStore.getFilterSortBy,
    per_page: getFirstQueryValue(route.query?.per_page) || demoShiftControlStore.getPerPage,
    page: getFirstQueryValue(route.query?.current_page) || demoShiftControlStore.getCurrentPage,
  }))

  return runApiGet<DemoSlotsPaginatedData>(url, {
    setLoading: (loading) => demoShiftControlStore.setLoading(loading),
    handle: (response) => {
      const paginatedData: DemoSlotsPaginatedData | null = response?.data || null
      demoShiftControlStore.setSlotsPaginatedData(paginatedData)
      return paginatedData
    },
    hooks: options,
  })
}
